var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 4"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":3},React.createElement("g",{"id":"Pledge---Layout","transform":"translate(-991.000000, -2953.000000)","stroke":"#FFFFFF"},React.createElement("g",{"id":"Page-1","transform":"translate(995.500000, 2957.000000) rotate(-90.000000) translate(-995.500000, -2957.000000) translate(991.500000, 2952.500000)"},React.createElement("g",{"id":"Group-7"},React.createElement("g",{"id":"Group-4"},[React.createElement("path",{"d":"M4,8.86956522 L4,0.730434783","id":"Stroke-3","key":0}),React.createElement("polyline",{"id":"Stroke-5","points":"7.44347826 5.42608696 4 8.86956522 0.556521739 5.42608696","key":1})])))))]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"width":"10px","height":"8px","viewBox":"0 0 10 8","version":"1.1"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-react-loader/lib/loader.js?name=Icon!./client/assets/icons/submit-arrow.svg
// module id = 1256
// module chunks = 0